'use client';

import { Input, type InputProps } from '@heroui/input';
import { Mail } from 'lucide-react';
import {
    type Control,
    Controller,
    type FieldValues,
    type Path,
    useFormState,
} from 'react-hook-form';

interface ControlledEmailInputProps<T extends FieldValues> extends InputProps {
    control: Control<T>;
    name: Path<T>;
}

export function ControlledEmailInput<T extends FieldValues>({
    control,
    name,
    ...props
}: ControlledEmailInputProps<T>) {
    const { errors } = useFormState({ control, name });

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <Input
                    {...field}
                    autoComplete="email webauthn"
                    errorMessage={errors[name]?.message as string}
                    isInvalid={!!errors[name]}
                    label="Email Address"
                    labelPlacement="outside"
                    placeholder="JohnDoe@example.com"
                    startContent={<Mail className="text-default-400" />}
                    type="email"
                    variant="bordered"
                    {...props}
                />
            )}
        />
    );
}
